import { BranchDto } from './branch-dto.model';
import { BankDto } from './bank-dto.model';
import { DepartmentDto } from './department-dto.model';
import { DesignationDto } from './designation-dto.model';


export class PermanentEmployeeDto implements IPermanentEmployeeDto {
    id!: number;
    empName!: string | undefined;
    referenceBy!: string | undefined;
    branch!: BranchDto;
    isActive!: boolean;
    bank!: BankDto;
    bankAccNo!: string | undefined;
    ifscCode!: string | undefined;
    joinDate!: Date;
    resignDate!: Date | undefined;
    department!: DepartmentDto;
    designation!: DesignationDto;
    salary!: number;
    companyId!: number;

    constructor(data?: IPermanentEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empName = _data["empName"];
            this.referenceBy = _data["referenceBy"];
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.bank = _data["bank"] ? BankDto.fromJS(_data["bank"]) : <any>undefined;
            this.bankAccNo = _data["bankAccNo"];
            this.ifscCode = _data["ifscCode"];
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.resignDate = _data["resignDate"] ? new Date(_data["resignDate"].toString()) : <any>undefined;
            this.department = _data["department"] ? DepartmentDto.fromJS(_data["department"]) : <any>undefined;
            this.designation = _data["designation"] ? DesignationDto.fromJS(_data["designation"]) : <any>undefined;
            this.salary = _data["salary"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): PermanentEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermanentEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empName"] = this.empName;
        data["referenceBy"] = this.referenceBy;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["bankAccNo"] = this.bankAccNo;
        data["ifscCode"] = this.ifscCode;
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        data["salary"] = this.salary;
        data["companyId"] = this.companyId;
        return data; 
    }
}

export interface IPermanentEmployeeDto {
    id: number;
    empName: string | undefined;
    referenceBy: string | undefined;
    branch: BranchDto;
    isActive: boolean;
    bank: BankDto;
    bankAccNo: string | undefined;
    ifscCode: string | undefined;
    joinDate: Date;
    resignDate: Date | undefined;
    department: DepartmentDto;
    designation: DesignationDto;
    salary: number;
    companyId: number;
}

